import React from 'react';
import useCheckIfCurrentCompanyIsPECO from 'utils/Hooks/CompanySpecific/PECO/useCheckIfCurrentCompanyIsPECO';
import styles from './tenant-portal-logo.module.css';

const TenantPortalLogo: React.FC = () => {
    const { isCurrentCompanyDetermined, idMatch: isPECOCurrentCompany } = useCheckIfCurrentCompanyIsPECO();

    if (!isCurrentCompanyDetermined) return null;

    return (
        <>
            {isPECOCurrentCompany ? (
                <img className={styles.Logo} src={`${ROOT}assets/dashcomm/logos/dashcomm_500.png`} alt="Dashcomm Logo" />
            ) : (
                <img
                    className={styles.Logo}
                    src="https://s3.amazonaws.com/tenant-portal.idplans.com/assets/logos/IDTenant-Logo_500.png"
                    alt="ID Plans Tenant Portal Logo"
                />
            )}
        </>
    );
};

export default TenantPortalLogo;
